import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CookieService } from 'ngx-cookie-service';
import { CoreService } from 'src/app/services/core.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  tokenSSLoged: boolean = false;

  constructor(private cookies: CookieService, private coreService: CoreService) {
    this.tokenSSLoged = this.cookies.check('UL');
  }

  ngOnInit() {
    this.coreService.emitSubjet.subscribe(response => {
      if (response.type === 'RefreshLoged') {
        this.tokenSSLoged = this.cookies.check('UL');
      }
    });
  }
}
